/**
 *
 * @param data String to encode
 * @returns base64 string
 */
export const encode = (data: string) => {
  try {
    return btoa(data)
  } catch (err) {
    console.error('Cannot encode string to base64', err)
  }
}

/**
 *
 * @param data String to decode
 * @returns normal string
 */
export const decode = (data: string) => {
  try {
    return atob(data)
  } catch (err) {
    console.error('Cannot decode string to base64', err)
  }
}
